import Link from "@components/anti/Link"
import { translations } from "src/helper/translations"
import { useScrollAnim } from "src/hooks/hooks"
import { convertHtmlToReact } from "src/mixins"

function ProductServicesTheBallroomMaps({ data, locale }) {
  const [trigger, anim] = useScrollAnim()
  return (
    <section className="sc-concessions-location" ref={trigger}>
      <div className="py-main">
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-text pr-md-5">
              <h2 className={`title ${anim(1)}`}>
                {translations[`concession_location_ballroom_${locale}`]}
              </h2>
              <Link
                withArrow
                target="_blank"
                href={data?.map_link_url}
                className={`btn-google ${anim(4)}`}
              >
                {translations[`view_google_maps_${locale}`]}
              </Link>
            </div>
            <div className="col-md-8 col-maps">
              <>{convertHtmlToReact(data?.embed_source)}</>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProductServicesTheBallroomMaps
